var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('side-bar',{attrs:{"layout":"admin"}}),_c('div',{staticClass:"content ht-100v pd-0"},[_c('Header'),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }